import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useCustomError } from 'hooks/useCustomError'
import ListRow from 'static/components/StoreLocator/ListRow'
import VirtualizedList from 'components/common/VirtualizedList'
import { isMobile } from 'utils/utils'
import type { ListOnScrollProps } from 'react-window'
import type { ListProps } from './ListProps'

const ListContainer = styled.ul`
	overflow-y: auto;
	max-height: 627px;
	list-style-type: none;
	padding: 0;
	margin: 0;
`

const VirtualizedListContainer = styled.div`
	height: 627px;
`

const ListItem = styled.li`
	padding: 0 10px;
`

const SIZE_OF_CARDS_GAPS = 20
const DEFAULT_SIZE_OF_CARD = 300
const SCROLL_DOWN_AMOUNT = 250

const List = ({
	updatedStores,
	locale,
	onSelectedStore,
	infra,
	isGeneratedStatically,
	setModalOpen,
	params,
	hasStores,
	user,
}: ListProps) => {
	const setCustomError = useCustomError()
	const [scrolledDown, setScrolledDown] = useState(false)

	const onScrolledToTopOfThePage = () => {
		if (window.scrollY === 0) {
			setScrolledDown(false)
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', onScrolledToTopOfThePage)

		return () => window.removeEventListener('scroll', onScrolledToTopOfThePage)
	}, [])

	const onScroll = ({ scrollOffset }: ListOnScrollProps) => {
		if (scrollOffset > 10) {
			if (isMobile(false) && !scrolledDown) {
				const mapElement = document.getElementById('map-container')
				const sizes = mapElement?.getBoundingClientRect()
				window.scrollBy({ top: (sizes?.bottom || 0) - 50 || SCROLL_DOWN_AMOUNT, behavior: 'smooth' })
				setScrolledDown(true)
			}
		}
	}

	return (
		<VirtualizedListContainer>
			<VirtualizedList
				gapSize={SIZE_OF_CARDS_GAPS}
				cardSize={DEFAULT_SIZE_OF_CARD}
				listContainer={ListContainer}
				data={updatedStores}
				onScroll={onScroll}
				renderProps={(data, index, setSize, style, innerRef) => (
					<ListItem style={style}>
						<ListRow
							innerRef={innerRef}
							index={index}
							stores={data}
							locale={locale}
							rank={index + 1}
							infra={infra}
							user={user}
							hasStores={hasStores}
							isGeneratedStatically={isGeneratedStatically}
							params={params}
							setModalOpen={setModalOpen}
							setCustomError={setCustomError}
							onSelectedStore={onSelectedStore}
						/>
					</ListItem>
				)}
			/>
		</VirtualizedListContainer>
	)
}

export default List
